import { add } from "./base";
class Handler {
    settings;
    constructor(settings) {
        this.settings = settings;
    }
    toString(data) {
        return typeof data == "string" ? data : "";
    }
    fromString(value) {
        return typeof value == "string" && !!value ? value : undefined;
    }
    partialFormat = this.format;
    format(unformatted) {
        return { ...unformatted, type: "text", ...this.settings };
    }
    unformat(formatted) {
        return formatted;
    }
    allowed(symbol, state) {
        return (this.settings.length == undefined ||
            this.settings.length[1] == undefined ||
            state.value.length < this.settings.length[1]);
    }
}
add("text", (settings) => new Handler(settings || {}));
//# sourceMappingURL=text.js.map